import {deleteImage} from "../actions/deleteImage";

function imageWrapperIconDelete() {
    $('.image-wrapper .icon-delete').click(function () {
        event.preventDefault();
        event.stopPropagation();

        deleteImage($(this).closest('.image-wrapper').attr('data-id'))
    });
}

export {imageWrapperIconDelete};
